import { roundPrice } from '../utils/number';
import KeyboardEventHelper from '../utils/keyboardEventHelper';

interface Currency {
  [key: string]: any;
}

export const Currencies: Currency = {
  EUR: {
    Code: 'EUR',
    Symbol: '€',
    ThousandsSeparator: '.',
    DecimalSeparator: ',',
    SymbolOnLeft: false,
    SpaceBetweenAmountAndSymbol: true,
    DecimalDigits: 2,
    ISONum: 978,
    Validator: KeyboardEventHelper.allowOnlyDecimalNumbers,
    RoundPrice: (amount: number) => amount,
    Round: (amount: number) => Math.round(amount * 100) / 100,
  },
  CZK: {
    Code: 'CZK',
    Symbol: 'Kč',
    ThousandsSeparator: ' ',
    DecimalSeparator: ',',
    SymbolOnLeft: false,
    SpaceBetweenAmountAndSymbol: true,
    DecimalDigits: 0,
    ISONum: 203,
    Validator: KeyboardEventHelper.allowOnlyNumeric,
    RoundPrice: (amount: number) => roundPrice(amount),
    Round: (amount: number) => Math.round(amount),
  },
  PLN: {
    Code: 'PLN',
    Symbol: 'zł',
    ThousandsSeparator: ' ',
    DecimalSeparator: ',',
    SymbolOnLeft: false,
    SpaceBetweenAmountAndSymbol: true,
    DecimalDigits: 2,
    ISONum: 985,
    Validator: KeyboardEventHelper.allowOnlyDecimalNumbers,
    RoundPrice: (amount: number) => amount,
    Round: (amount: number) => Math.round(amount * 100) / 100,
  },
  RON: {
    Code: 'RON',
    Symbol: 'lei',
    ThousandsSeparator: '.',
    DecimalSeparator: ',',
    SymbolOnLeft: false,
    SpaceBetweenAmountAndSymbol: true,
    DecimalDigits: 2,
    ISONum: 946,
    Validator: KeyboardEventHelper.allowOnlyDecimalNumbers,
    RoundPrice: (amount: number) => amount,
    Round: (amount: number) => Math.round(amount * 100) / 100,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export type currencyCode = keyof typeof Currencies;

export const getCurrencyByCode = (code: currencyCode) => Currencies[code];

export const getCurrencyISONum = (code: string) => {
  return Currencies[code].ISONum;
};

export const getCurrencySymbol = (code: string) => {
  return Currencies[code].Symbol;
};

export const CURRENCY_TYPES = Object.keys(Currencies).reduce(
  (acc, curr) => ({ ...acc, curr }),
  {}
) as {
  [code in currencyCode]: code;
};
